import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="mb-8 flex flex-col items-center gap-2">
        <span className="text-2xl font-bold text-gray-900">Fast Policy Enterprise</span>
        <span className="text-sm text-gray-500">Powered by Fastclaim</span>
      </div>
      <Outlet />
    </div>
  );
}
